import React, {Fragment} from 'react';
import { Header,  Form,  Radio,  Label } from 'semantic-ui-react';
import Field from '../Field';
import CountryDropdown from '../CountryDropdown'
import VerificationFormField from '../VerificationFormField'
import withVericationForm from './withVericationForm'
import yup from 'yup';

const ERROR_REQUIRED = 'This field is required'

class IdForm extends React.PureComponent {

  isIdInputDisabled = () => {
    const {values} = this.props
    const valuesToValidate = [
      values.validName,
      values.validSignatureReadable
    ]
    return this.props.isInputDisabled(valuesToValidate)
  }

  _onChange = (e, {name, value} ) => {
    this.props.onChange(this.props.documentId, name, value)
  }

  render = () => {

    const {
      onBlur,
      values,
      errors,
      touched
    } = this.props;
    const isIDInputDisabled = this.isIdInputDisabled()
    return (
    <Fragment>
      <Header>
        ID
      </Header>
      <Form>
        <Field
          error={errors.validName}
          touched={touched.validName}
        >
          <VerificationFormField
            name="validName"
            value={values.validName}
            onChange={this._onChange}
            onBlur={onBlur.bind(this, 'validName')}>
              <p>The name on the document is </p>
              <Label>
                {this.passengerName()}
              </Label>
          </VerificationFormField>
        </Field>
        <Field
          error={errors.validSignatureReadable}
          touched={touched.validSignatureReadable}
        >
          <VerificationFormField
            name="validSignatureReadable"
            value={values.validSignatureReadable}
            onChange={this._onChange}
            onBlur={onBlur.bind(this, 'validSignatureReadable')}>

            <p>Is the signature readable?</p>

          </VerificationFormField>
        </Field>
        <Field
          error={errors.dateOfBirth}
          touched={touched.dateOfBirth}
        >
          <Form.Input
            label="Date of birth"
            name="dateOfBirth"
            value={values.dateOfBirth}
            onChange={this._onChange}
            placeholder="DD/MM/YYYY"
            disabled={isIDInputDisabled}
            onBlur={onBlur.bind(this, 'dateOfBirth')}
          />
        </Field>
        <Field
          error={errors.placeOfBirth}
          touched={touched.placeOfBirth}
        >
          <Form.Input
            label="Place of birth"
            name="placeOfBirth"
            placeholder="Place of birth"
            value={values.placeOfBirth}
            onChange={this._onChange}
            disabled={isIDInputDisabled}
            onBlur={onBlur.bind(this, 'placeOfBirth')}
          />
        </Field>
        <Field
          error={errors.gender}
          touched={touched.gender}
        >
          <Form.Field inline>
            <Radio
              label="Male"
              name="gender"
              value="male"
              checked={values.gender === "male"}
              onChange={this._onChange}
              disabled={isIDInputDisabled}
              onBlur={onBlur.bind(this, 'gender')}
            />
            <Radio
              label="Female"
              name="gender"
              value="female"
              checked={values.gender === "female"}
              onChange={this._onChange}
              disabled={isIDInputDisabled}
              onBlur={onBlur.bind(this, 'gender')}
            />
          </Form.Field>
        </Field>
        <Field
          error={errors.nationality}
          touched={touched.nationality}
        >
          <CountryDropdown
            disabled={isIDInputDisabled}
            name="nationality"
            label="Nationality"
            placeholder="Nationality"
            value={values.nationality}
            onBlur={onBlur.bind(this, 'nationality')}
            onChange={this._onChange}
          />
        </Field>
      </Form>
    </Fragment>

    )
  }

  passengerName(){
    const passenger_ticket = this.props.passengerTicket
    if(!passenger_ticket){
      return ''
    }
    return [
      passenger_ticket.passengerFirstName,
      passenger_ticket.passengerLastName].join(' ')
  }
}

const formikConfig = {
  mapPropsToValues: props => {
    return {...props.formValues}
  },
  validateOnChange: false,
  validationSchema: () => {
    const fields = ['validName', 'validSignatureReadable']
    const test = {
      is: true,
      then: yup.string().required(ERROR_REQUIRED)
    }
    return yup.object().shape({
      validName: yup.boolean().required(ERROR_REQUIRED),
      validSignatureReadable: yup.boolean().required(ERROR_REQUIRED),
      dateOfBirth: yup.string()
        .when(fields, test),
      placeOfBirth: yup.string()
        .when(fields, test),
      gender: yup.string()
        .when(fields, test),
      nationality: yup.string()
        .when(fields, test)
    })
  }
}

export default withVericationForm(formikConfig, ['validName', 'dateOfBirth', 'placeOfBirth', 'gender','nationality', 'validSignatureReadable'])(IdForm)



// WEBPACK FOOTER //
// ./src/component/verification_forms/IdForm.js